<template>
  <div class="dashboard">
    <v-layout row wrap class="my-5 px-1">
      <v-flex xs12 sm12 md12>
        <v-layout wrap row justify-start class="mb-3" align-center align-content-center FILTERS>
          <v-flex xs6  pa-1>
            <v-text-field
              label="Search..."
              hide-details
              solo
              v-model="searchText"
              @input="filterLeads()"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-select
              :items="statuses"
              hide-details
              clearable
              solo :loading="loading"
              @change="filterLeads()"
              v-model="status"
              label="Select A Status"
            ></v-select>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-select
              :items="company_codes"
              hide-details
              clearable
              solo :loading="loading"
              @change="filterLeads()"
              v-model="company_code"
              label="Select A Company"
            ></v-select>
          </v-flex>
          <v-flex xs3 pa-1>
            <v-select
              :items="ShippingStatuses"
              hide-details
              clearable
              solo :loading="loading"
              @change="filterLeads()"
              v-model="ShippingStatus"
              label="Select A Shipping Status"
            ></v-select>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-menu
              v-model="fDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="f_date"
                  label="Import From Date"
                  append-icon="event"
                  @change="filterLeads()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="f_date" @change="filterLeads()" @input="fDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-menu
              v-model="tDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="t_date"
                  label="Import To Date"
                  append-icon="event"
                  @change="filterLeads()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="t_date" @change="filterLeads()" @input="tDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-menu
              v-model="fuDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="fu_date"
                  label="Update From Date"
                  append-icon="event"
                  @change="filterLeads()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="fu_date" @change="filterLeads()" @input="fuDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 pa-1>
            <v-menu
              v-model="tuDate"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template slot="activator">
                <v-text-field
                  v-model="tu_date"
                  label="Update To Date"
                  append-icon="event"
                  @change="filterLeads()"
                  readonly
                  solo :loading="loading"
                  clearable
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker v-model="tu_date" @change="filterLeads()" @input="tuDate = false"></v-date-picker>
            </v-menu>
          </v-flex>
          
          
          <v-flex xs2 px-1>
            <v-switch :label="`Exclude Up`" v-model="no_up_campaign" @change="filterLeads()" ></v-switch>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs2 px-1>
                <v-btn color="primary" block large @click="exportAll()">export</v-btn>
              </v-flex>
              <v-flex xs2 px-1>
                <v-btn color="primary" block large @click="loadResource()">reload</v-btn>
              </v-flex>
              <v-flex xs2 px-1>
                <v-switch :label="`Realtime`" v-model="realtime" @change="realTime()" ></v-switch>
              </v-flex>
              <v-flex xs2 px-1>
                <v-switch label="Table" v-model="table"></v-switch>
              </v-flex>
              <v-flex xs4 pa-1 class="align-center align-content-center text-xs-center" align-content-center>
                <span v-if="resource" class="title">
                  <v-icon color="secondary">av_timer</v-icon>
                  {{resource.query_time}}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-progress-linear  v-if="loading"  :indeterminate="true"></v-progress-linear>
        </div>
        <v-layout row wrap py-3>
          <v-flex xs12 class="" STATSTOP>
            <v-layout row wrap py-3 align-center>
              <v-flex xs12 md3 class="px-1" v-if="resource">
                <v-card color="primary" dark class="py-3">
                  <v-layout row wrap >
                    <v-flex xs12 class="text-xs-center py-2">
                      <v-icon size="25">clear_all</v-icon>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center py-1">
                      # OF ORDERS
                    </v-flex>
                    <v-flex xs12 class="text-xs-center headline">
                      {{resource.total}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 class="px-1" v-if="resource">
                <v-card color="primary" dark class="py-3">
                  <v-layout row wrap >
                    <v-flex xs12 class="text-xs-center py-2">
                      <v-icon size="25">account_balance</v-icon>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center py-1">
                      TOTAL INVOICE
                    </v-flex>
                    <v-flex xs12 class="text-xs-center headline">
                      {{resource.total_invoice}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 class="px-1" v-if="resource">
                <v-card color="primary" dark class="py-3">
                  <v-layout row wrap >
                    <v-flex xs12 class="text-xs-center py-2">
                      <v-icon size="25">shopping_cart</v-icon>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center py-1">
                      AVG. TOTAL INVOICE
                    </v-flex>
                    <v-flex xs12 class="text-xs-center headline">
                      {{resource.average_total_invoice}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md3 class="px-1" v-if="realtime">
                <v-card color="primary" dark class="py-3">
                  <v-layout row wrap >
                    <v-flex xs12 class="text-xs-center py-2">
                      <v-icon size="25">timer</v-icon>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center py-1">
                      Time To Next Update
                    </v-flex>
                    <v-flex xs12 class="text-xs-center headline">
                      {{time}}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="table" class="tableDiv">
          <v-flex xs12>
            <v-data-table
              :headers="TableHeaders"
              :items="TableData"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td v-for="(h, i) in TableHeaders" :key="'-val-' + i">
                  <span v-if="h.value != 'company_code' && props.item[h.value]">
                    <v-tooltip top>
                      <span slot="activator" class="pa-1">
                        <div style="font-weight:bold;">{{ props.item[h.value].per_total.toFixed(1) }}%</div>
                        <div>{{ props.item[h.value].total }} orders</div>
                        <div>BASKET: ${{ (props.item[h.value].sum / props.item[h.value].total).toFixed(1) }} </div>
                        <div style="font-size:11px;">${{ props.item[h.value].sum.toFixed(1) }}</div>
                        <v-divider></v-divider>
                        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                        <v-btn color="primary" :loading="loading" text flat small block 
                          @click="exportItem(h.value, props.item.company_code)">
                          export
                        </v-btn>
                      </span>
                      <span>
                        <div>SUM: ${{ props.item[h.value].sum.toFixed(1) }}</div>
                        <div>TOTAL: {{ props.item[h.value].total }} orders</div>
                        <div>BASKET AVG: ${{ (props.item[h.value].sum / props.item[h.value].total).toFixed(1) }}</div>
                        <div>GRAND SUM: ${{ props.item[h.value].grand_sum.toFixed(1) }}</div>
                        <div>GRAND TOTAL: {{ props.item[h.value].grand_total }} orders</div>
                        <div>SUM PERCENTAGE: {{ props.item[h.value].per_sum.toFixed(1) }}%</div>
                        <div>TOTAL PERCENTAGE: {{ props.item[h.value].per_total.toFixed(1) }}%</div>
                      </span>
                    </v-tooltip>
                  </span>
                  <span v-if="h.value == 'company_code'" style="font-weight:bold;">
                    <div>{{props.item[h.value]}}</div>
                    <div style="font-size:9px;">${{ props.item.grand_sum }}</div>
                    <div style="font-size:9px;">({{ props.item.grand_total }} orders)</div>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="table" class="tableDiv">
          <v-flex xs12 >
            <v-text-field
              v-model="searchCampaign"
              append-icon="search"
              label="Search"
              solo
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="CampaignsTableHeaders"
              :items="CampaignsTableData"
              class="elevation-1"
              :search="searchCampaign"
            >
              <template v-slot:items="props">
                <td v-for="(h, i) in CampaignsTableHeaders" :key="'-val-' + i">
                  <span v-if="status_cats.includes(h.value) && props.item[h.value]">
                    <v-tooltip top>
                      <span slot="activator" class="pa-1">
                        <div style="font-weight:bold;">{{ props.item[h.value].per_total.toFixed(1) }}%</div>
                        <div>{{ props.item[h.value].total }} orders</div>
                        <div>BASKET: ${{ (props.item[h.value].sum / props.item[h.value].total).toFixed(1) }} </div>
                        <div style="font-size:11px;" v-if="props.item[h.value].sum">${{ props.item[h.value].sum }}</div>

                        <v-divider></v-divider>
                        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                        <v-btn color="primary" :loading="loading" text flat small block 
                          @click="exportItem(h.value, props.item.company_code, props.item.campaign_code)">
                          export
                        </v-btn>
                      </span>
                      <span>
                        <div>TOTAL: {{ props.item[h.value].total }} orders</div>
                        <div v-if="props.item[h.value].sum">SUM: ${{ props.item[h.value].sum }}</div>
                        
                      </span>
                    </v-tooltip>
                  </span>
                  <span v-if="!status_cats.includes(h.value)" style="font-weight:bold;">
                    <div v-if="h.value == 'company_code'">{{props.item[h.value].replace(/_/g, ' ').toUpperCase()}}</div>
                    <div v-else-if="h.value == 'sku'">
                      <v-tooltip top>
                        <span slot="activator" class="pa-1">
                          <div>{{props.item[h.value]}}</div>
                          <div style="font-size:9px;">${{ props.item.grand_sum }}</div>
                          <div style="font-size:9px;">({{ props.item.grand_total }} orders)</div>
                        </span>
                        <span>
                          <div>ITEM: {{ props.item.item_name }}</div>
                        </span>
                      </v-tooltip>
                    </div>
                    <div v-else>{{props.item[h.value]}}</div>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="table" class="tableDiv">
          <v-flex xs12 >
            <v-text-field
              v-model="searchProducts"
              append-icon="search"
              label="Search"
              solo
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-data-table
              :headers="ProductsTableHeaders"
              :items="ProductsTableData"
              class="elevation-1"
              :search="searchProducts"
            >
              <template v-slot:items="props">
                <td v-for="(h, i) in ProductsTableHeaders" :key="'-val-' + i">
                  <span v-if="status_cats.includes(h.value) && props.item[h.value]">
                    <v-tooltip top>
                      <span slot="activator" class="pa-1">
                        <div>{{ props.item[h.value].total }} orders</div>
                        <div style="font-size:11px;" v-if="props.item[h.value].sum">${{ props.item[h.value].sum }}</div>

                        <v-divider></v-divider>
                        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
                        <v-btn color="primary" :loading="loading" text flat small block 
                          @click="exportItem(h.value, props.item.company_code, props.item.sku)">
                          export
                        </v-btn>
                      </span>
                      <span>
                        <div>TOTAL: {{ props.item[h.value].total }} orders</div>
                        <div v-if="props.item[h.value].sum">SUM: ${{ props.item[h.value].sum }}</div>
                        
                      </span>
                    </v-tooltip>
                  </span>
                  <span v-if="!status_cats.includes(h.value)" style="font-weight:bold;">
                    <div v-if="h.value == 'company_code'">{{props.item[h.value].replace(/_/g, ' ').toUpperCase()}}</div>
                    <div v-else-if="h.value == 'sku'">
                      <div>{{props.item[h.value]}}</div>
                      <div style="font-size:9px;">${{ props.item.grand_sum }}</div>
                      <div style="font-size:9px;">({{ props.item.grand_total }} orders)</div>
                      <div style="font-size:9px;">({{ props.item.rate_quantity }} item/orders)</div>
                    </div>
                    <div v-else>{{props.item[h.value]}}</div>
                  </span>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 class="text-xs-center">
            <v-pagination
              v-if="resource"
              v-model="resource.current_page"
              class="my-0"
              :total-visible="7"
              color="primary"
              @input="pageByNumber"
              :length="resource.last_page"
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12>
        <v-layout row wrap py-3 v-if="!table">
          <v-flex xs12 sm12 md12 pa-1 v-for="(lead, l) in resource.data" :key="'lead-' + l">
            <v-card>
              <v-layout row wrap pa-3>
                <v-flex xs12 md2>
                  <div>{{lead.created_at.split('T')[0]}}</div>
                  <div>{{lead.created_at.split('T')[1].split('.')[0]}}</div>
                </v-flex>
                <v-flex xs12 md2>
                  <div style="font-size:11px;">{{lead.key}}</div>
                  <div>{{lead.name}}</div>
                  <div>{{lead.phone_number_1}}</div>
                </v-flex>
                <v-flex xs12 md2>
                  <div style="text-transform:uppercase;font-weight:bold;">{{lead.company_code}}</div>
                  <div style="text-transform:uppercase;font-weight:light;">{{lead.order_status}}</div>
                </v-flex>
                <v-flex xs12 md2>
                  ${{lead.total_invoice}}
                </v-flex>
                <v-flex xs12 md2>
                  <div v-for="(item, s) in lead.order" :key="'item-'+s+item+l">{{item.quantity}} X {{item.sku}}</div>
                  <div v-for="(item, s) in lead.variant" :key="'variant-'+s+item+l">{{item.quantity}} X {{item.sku}}</div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {firebase, db, auth, store} from '@/fb'
import { titleCase, randomString } from '@/customFunction'
import { nonHuman, Human, noAnswer, confirmed } from '@/status'
import axios from 'axios';
import json2csv from 'json2csv'
export default {
  data() {
    return {
      status_cats:['non_human', 'human', 'no_answer', 'confirmed'],
      nonHuman, 
      Human, 
      noAnswer, 
      confirmed,
      statuses:[],
      ShippingStatuses:[],
      company_codes:[],
      searchText:'',
      loading:false,
      currentPage: 1,
      pageSize: 7,
      pagesNumber:0,
      filteredLeads:0,
      status:null,
      ShippingStatus:null,
      company_code:null,
      fDate:null,
      f_date:null,
      tDate:null,
      t_date:null,
      fuDate:null,
      fu_date:null,
      tuDate:null,
      tu_date:null,
      resource:null,
      stats:[],
      TableHeaders:[],
      TableData:[],
      CampaignsTableHeaders:[],
      CampaignsTableData:[],
      ProductsTableHeaders:[],
      ProductsTableData:[],
      table:true,
      interval:null,
      realtime:false,
      time:60,
      timerInterval:null,
      no_up_campaign:true,
      searchCampaign:null,
      searchProducts:null,
    }
  },
  props:{
  },
  methods:{
    async filterLeads(){
      await this.loadResource()
    },
    buildFilter(){
      let filter = ``
      if(!this.f_date) this.f_date = new Date( new Date().getTime() - 24*60*60*1000 ).toISOString().split('T')[0]
      if(!this.t_date) this.t_date = new Date().toISOString().split('T')[0]
      if(this.f_date && this.t_date) {
        filter += `&filter[in_between_create]=${this.f_date},${this.t_date}`
      }
      if(this.fu_date && this.tu_date) {
        filter += `&filter[in_between_update]=${this.fu_date},${this.tu_date}`
      }
      if(this.status) {
        filter += `&filter[order_status]=${this.status}`
      }
      if(this.company_code) {
        filter += `&filter[company_code]=${this.company_code}`
      }
      if(this.no_up_campaign) {
        filter += `&filter[no_up]=${this.no_up_campaign}`
      }
      return filter
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.search)
        if(!this.search){
          
          this.resource = await this.$store.dispatch('getResource', {resource:'/leads' + '?' + this.buildFilter()})
          this.statuses = this.resource.order_statuses.filter(x=>x).map(x=>{return {text:x.replace(/_/g, ' ').toUpperCase(), value:x}})
          this.ShippingStatuses = this.resource.shipping_status.filter(x=>x).map(x=>{return {text:x.replace(/_/g, ' ').toUpperCase(), value:x}})
          this.company_codes = this.resource.company_codes.filter(x=>x).map(x=>{return {text:x.replace(/_/g, ' ').toUpperCase(), value:x}})
          this.buildTable(this.resource)
          this.buildCampaignTable(this.resource)
          this.buildProductsTable(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/leads' + '/search', value:this.searchText})
        }
        this.loading = false
        res()
      })
    },
    async buildTable(resource){
      let d = resource.group
      let data = {}
      let a, b, c = 0
      for (let i = 0; i < d.length; i++) {
        const st = d[i];
        for (const key in st) {
          if (Object.hasOwnProperty.call(st, key)) {
            const val = st[key];
            if(!val) {
              st[key] = 0
            }
          }
        }
        if(!data[st.company_code]) data[st.company_code] = { company_code:st.company_code.replace(/_/g, ' ').toUpperCase(), grand_total:st.grand_total, grand_sum:st.grand_sum}
        if(nonHuman.includes(st.order_status)) {
          if(!data[st.company_code].nonHuman) data[st.company_code].nonHuman = {total:0,sum:0,grand_sum:0,per_sum:0,grand_total:0,per_total:0,basket:0}
          a++
          data[st.company_code].nonHuman.total += parseFloat(st.total)
          data[st.company_code].nonHuman.sum += parseFloat(st.sum_total_invoice)
          data[st.company_code].nonHuman.grand_sum += parseFloat(st.grand_sum)
          data[st.company_code].nonHuman.per_sum += parseFloat(st.per_sum)
          data[st.company_code].nonHuman.grand_total += parseFloat(st.grand_total)
          data[st.company_code].nonHuman.per_total += parseFloat(st.per_total)
          // data[st.company_code].nonHuman.basket += parseFloat(st.basket)
        } else if(Human.includes(st.order_status)) {
          if(!data[st.company_code].Human) data[st.company_code].Human = {total:0,sum:0,grand_sum:0,per_sum:0,grand_total:0,per_total:0,basket:0}
          b++
          data[st.company_code].Human.total += parseFloat(st.total)
          data[st.company_code].Human.sum += parseFloat(st.sum_total_invoice)
          data[st.company_code].Human.grand_sum += parseFloat(st.grand_sum)
          data[st.company_code].Human.per_sum += parseFloat(st.per_sum)
          data[st.company_code].Human.grand_total += parseFloat(st.grand_total)
          data[st.company_code].Human.per_total += parseFloat(st.per_total)
          // data[st.company_code].Human.basket += parseFloat(st.basket)
        } else if(noAnswer.includes(st.order_status)) {
          if(!data[st.company_code].noAnswer) data[st.company_code].noAnswer = {total:0,sum:0,grand_sum:0,per_sum:0,grand_total:0,per_total:0,basket:0}
          c++
          data[st.company_code].noAnswer.total += parseFloat(st.total)
          data[st.company_code].noAnswer.sum += parseFloat(st.sum_total_invoice)
          data[st.company_code].noAnswer.grand_sum += parseFloat(st.grand_sum)
          data[st.company_code].noAnswer.per_sum += parseFloat(st.per_sum)
          data[st.company_code].noAnswer.grand_total += parseFloat(st.grand_total)
          data[st.company_code].noAnswer.per_total += parseFloat(st.per_total)
          // data[st.company_code].noAnswer.basket += parseFloat(st.basket)
        } else if(confirmed.includes(st.order_status)) {
          if(!data[st.company_code].confirmed) data[st.company_code].confirmed = {total:0,sum:0,grand_sum:0,per_sum:0,grand_total:0,per_total:0,basket:0}
          data[st.company_code].confirmed.total += parseFloat(st.total)
          data[st.company_code].confirmed.sum += parseFloat(st.sum_total_invoice)
          data[st.company_code].confirmed.grand_sum += parseFloat(st.grand_sum)
          data[st.company_code].confirmed.per_sum += parseFloat(st.per_sum)
          data[st.company_code].confirmed.grand_total += parseFloat(st.grand_total)
          data[st.company_code].confirmed.per_total += parseFloat(st.per_total)
          // data[st.company_code].confirmed.basket += parseFloat(st.basket)
        } else {
          if(!data[st.company_code][st.order_status]) data[st.company_code][st.order_status] = {total:0,sum:0,grand_sum:0,per_sum:0,grand_total:0,per_total:0,basket:0}
          data[st.company_code][st.order_status].total = parseFloat(st.total)
          data[st.company_code][st.order_status].sum = parseFloat(st.sum_total_invoice)
          data[st.company_code][st.order_status].grand_sum = parseFloat(st.grand_sum)
          data[st.company_code][st.order_status].per_sum = parseFloat(st.per_sum)
          data[st.company_code][st.order_status].grand_total = parseFloat(st.grand_total)
          data[st.company_code][st.order_status].per_total = parseFloat(st.per_total)
          // data[st.company_code][st.order_status].basket = parseFloat(st.basket)
        }
      }

      console.log(data)

      this.TableHeaders = [
        {text:'COMPANY CODE', value:'company_code'}, 
        ...resource.order_statuses
        .filter(x=> x && !nonHuman.includes(x) && !Human.includes(x) && !noAnswer.includes(x) && !confirmed.includes(x))
        .map(x=>{return {text:x.replace(/_/g, ' ').toUpperCase(), value:x}}),
        {text:'NON HUMAN', value:'nonHuman'}, 
        {text:'HUMAN', value:'Human'}, 
        {text:'NO ANSWER', value:'noAnswer'}, 
        {text:'CONFIRMED', value:'confirmed'}, 
      ]
      this.TableData = Object.values(data)
    },
    async buildCampaignTable(resource) {
      let d = resource.campaigns
      let data = {}
      for (let i = 0; i < d.length; i++) {
        const st = d[i];
        if(!data[st.sku]) data[st.sku] = st
        if(st.status_category == 'non_human') {
          if(!data[st.sku].non_human) data[st.sku].non_human = {total:st.total_company_code, sum:st.sum_total_invoice, per_total:st.per_total}
        } else if(st.status_category == 'human') {
          if(!data[st.sku].human) data[st.sku].human = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        } else if(st.status_category == 'no_answer') {
          if(!data[st.sku].no_answer) data[st.sku].no_answer = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        } else if(st.status_category == 'confirmed') {
          if(!data[st.sku].confirmed) data[st.sku].confirmed = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        }
      }
      this.CampaignsTableHeaders = [
        {text:'CAMPAIGN CODE', value:'sku'}, 
        {text:'Orders', value:'grand_total'}, 
        {text:'COMPANY CODE', value:'company_code'}, 
        {text:'NON HUMAN', value:'non_human'}, 
        {text:'HUMAN', value:'human'}, 
        {text:'NO ANSWER', value:'no_answer'}, 
        {text:'CONFIRMED', value:'confirmed'}, 
      ]
      console.log(d)
      this.CampaignsTableData = Object.values(data)
    },
    async buildProductsTable(resource) {
      let d = resource.orders
      console.log('resource.orders', resource.orders)
      let data = {}
      for (let i = 0; i < d.length; i++) {
        const st = d[i];
        if(!data[st.sku+st.company_code]) data[st.sku+st.company_code] = st
        if(st.status_category == 'non_human') {
          if(!data[st.sku+st.company_code].non_human) data[st.sku+st.company_code].non_human = {total:st.total_company_code, sum:st.sum_total_invoice, per_total:st.per_total}
        } else if(st.status_category == 'human') {
          if(!data[st.sku+st.company_code].human) data[st.sku+st.company_code].human = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        } else if(st.status_category == 'no_answer') {
          if(!data[st.sku+st.company_code].no_answer) data[st.sku+st.company_code].no_answer = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        } else if(st.status_category == 'confirmed') {
          if(!data[st.sku+st.company_code].confirmed) data[st.sku+st.company_code].confirmed = {total:st.total_company_code, sum:st.sum_total_invoice,per_total:st.per_total}
        }
      }
      this.ProductsTableHeaders = [
        {text:'SKU', value:'sku'}, 
        {text:'ORDERS', value:'grand_total'}, 
        {text:'QUANTITY', value:'total_quantity'}, 
        {text:'COMPANY CODE', value:'company_code'}, 
        {text:'NON HUMAN', value:'non_human'}, 
        {text:'HUMAN', value:'human'}, 
        {text:'NO ANSWER', value:'no_answer'}, 
        {text:'CONFIRMED', value:'confirmed'}, 
      ]
      console.log(d)
      console.log(data)
      this.ProductsTableData = Object.values(data)
    },
    async buildFastTable(resource){
      let d = resource.group_status
      let data = {}
      let a, b, c = 0
      for (let i = 0; i < d.length; i++) {
        const st = d[i];
        for (const key in st) {
          if (Object.hasOwnProperty.call(st, key)) {
            const val = st[key];
            if(!val) {
              st[key] = 0
            }
          }
        }
        if(!data[st.company_code]) data[st.company_code] = { company_code:st.company_code.replace(/_/g, ' ').toUpperCase(), grand_total:st.grand_total, grand_sum:st.grand_sum}
        if(!data[st.company_code][st.status_category]) data[st.company_code][st.status_category] = {}
        data[st.company_code][st.status_category].total = parseFloat(st.total)
        data[st.company_code][st.status_category].sum = parseFloat(st.sum_total_invoice)
        data[st.company_code][st.status_category].grand_sum = parseFloat(st.grand_sum)
        data[st.company_code][st.status_category].per_sum = parseFloat(st.per_sum)
        data[st.company_code][st.status_category].grand_total = parseFloat(st.grand_total)
        data[st.company_code][st.status_category].per_total = parseFloat(st.per_total)
      }

      console.log(data)

      this.TableHeaders = [
        {text:'COMPANY CODE', value:'company_code'}, 
        ...resource.order_statuses
        .filter(x=> x && !nonHuman.includes(x) && !Human.includes(x) && !noAnswer.includes(x) && !confirmed.includes(x))
        .map(x=>{return {text:x.replace(/_/g, ' ').toUpperCase(), value:x}}),
        {text:'NON HUMAN', value:'nonHuman'}, 
        {text:'HUMAN', value:'Human'}, 
        {text:'NO ANSWER', value:'noAnswer'}, 
        {text:'CONFIRMED', value:'confirmed'}, 
      ]
      this.TableData = Object.values(data)
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:'/leads', page:`?page=${n}` + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:'/leads' + `/search?page=${n}`, value:this.searchText})
        }
        this.loading = false
      })
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    exportAll(){
      this.exportData(this.resource.all, 'all_export')
    },
    async exportItem(status, cc, campaign = null) {
      console.log(status, cc, campaign)
      this.loading = true
      let company_code = cc.toLowerCase().replace(/ /g, '_')
      let filter = this.buildFilter()
      filter += `&filter[order_status]=${this[status].join(',')}`
      filter += `&filter[company_code]=${company_code}`
      if(campaign) {
        filter += `&filter[campaign_code]=${campaign}`
      }




      let data = await this.$store.dispatch('getResource', {resource:'/leads-all' + '?' + filter})
      console.log(data)
      let filtered = data.filter(x=>{
        if(this[status].includes(x.order_status) && x.company_code == company_code) {
          return x
        }
      })
      this.exportData(filtered, `export_${cc}_${status}`)
      this.loading = false
    },
    exportData(data, name){
      if(!data.length) {
        this.$emit('snackbarNotification', `No Data`, 'error')
        return true
      }
      console.log(data)
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'po_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    realTime(){
      if(this.realtime) {
        this.interval = setInterval(x=>{
          this.time = 60
          this.loadResource()
        }, 30000)
        this.timerInterval = setInterval(x=>{ this.time-- }, 1000)
      } else {
        clearInterval(this.interval)
        clearInterval(this.timerInterval)
        this.time = 60
      }
    }
  },
  watch:{
    
  },
  async created(){
    this.loadResource()
  }
}
</script>

<style>
.tableDiv ::-webkit-scrollbar-thumb
{
	background-color: #0d47a1;
	border-radius:  0; 
}

.tableDiv td {
    border-width: 0 1px 0 1px;
    border-style: solid;
    border-color: #e8e8e8;
    padding:0 5px !important;
}
</style>
